import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import AdminAuditLogs from "./pages/admin/AuditLogs";
import AdminBookings from "./pages/admin/Bookings";
import AdminDashboard from "./pages/admin/Dashboard";
import EmailDetailView from "./pages/admin/EmailDetailView";
import AdminEmails from "./pages/admin/Emails";
import AdminPenalties from "./pages/admin/Penalties";
import AdminSessions from "./pages/admin/Sessions";
import AdminSubjects from "./pages/admin/Subjects";
import AdminSystem from "./pages/admin/System";
import AdminThemeSettings from "./pages/admin/ThemeSettings";
import AdminUserDetail from "./pages/admin/UserDetail";
import AdminUsers from "./pages/admin/Users";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";
import ResetPassword from "./pages/auth/ResetPassword";
import Signup from "./pages/auth/Signup";
import VerifyEmail from "./pages/auth/VerifyEmail";
import BookingDetail from "./pages/bookings/BookingDetail";
import SessionPage from "./pages/sessions/SessionPage";
import BookingWizard from "./pages/student/BookingWizard";
import StudentDashboard from "./pages/student/Dashboard";
import StudentProfile from "./pages/student/Profile";
import StudentSessions from "./pages/student/Sessions";
import BrowseTutors from "./pages/tutor/Browse";
import TutorConfirm from "./pages/tutor/Confirm";
import TutorDashboard from "./pages/tutor/Dashboard";
import TutorProfile from "./pages/tutor/Profile";
import TutorSessions from "./pages/tutor/Sessions";
import TutorDetail from "./pages/tutor/TutorDetail";

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <AuthProvider>
        <ThemeProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="login" element={<Login />} />
              <Route path="signup" element={<Signup />} />
              <Route path="verify-email" element={<VerifyEmail />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="reset-password" element={<ResetPassword />} />

              <Route path="tutors" element={<BrowseTutors />} />
              <Route path="tutors/:id" element={<TutorDetail />} />

              <Route
                path="student/dashboard"
                element={
                  <ProtectedRoute allowedRoles={["student"]}>
                    <StudentDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="student/profile"
                element={
                  <ProtectedRoute allowedRoles={["student"]}>
                    <StudentProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="student/bookings/new"
                element={
                  <ProtectedRoute allowedRoles={["student"]}>
                    <BookingWizard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="student/sessions"
                element={
                  <ProtectedRoute allowedRoles={["student"]}>
                    <StudentSessions />
                  </ProtectedRoute>
                }
              />

              <Route
                path="tutor/dashboard"
                element={
                  <ProtectedRoute allowedRoles={["tutor"]}>
                    <TutorDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="tutor/profile"
                element={
                  <ProtectedRoute allowedRoles={["tutor"]}>
                    <TutorProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="tutor/sessions"
                element={
                  <ProtectedRoute allowedRoles={["tutor"]}>
                    <TutorSessions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="bookings/:bookingId/tutors/:tutorId/respond"
                element={<TutorConfirm />}
              />

              <Route
                path="bookings/:id"
                element={
                  <ProtectedRoute>
                    <BookingDetail />
                  </ProtectedRoute>
                }
              />

              <Route
                path="sessions/:id"
                element={
                  <ProtectedRoute>
                    <SessionPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="admin/dashboard"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/users"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminUsers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/users/:id"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminUserDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/subjects"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminSubjects />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/sessions"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminSessions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/bookings"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminBookings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/penalties"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminPenalties />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/emails"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminEmails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/emails/:id"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <EmailDetailView />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/system"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminSystem />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/audit-logs"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminAuditLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/theme"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AdminThemeSettings />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </>
  );
}

export default App;
